import { render, staticRenderFns } from "./buyer-dialog.vue?vue&type=template&id=fb820298&"
import script from "./buyer-dialog.vue?vue&type=script&lang=js&"
export * from "./buyer-dialog.vue?vue&type=script&lang=js&"
import style0 from "./buyer-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports